module.exports={
	"Form": "TeamEditManifest",
	"Scope": "Team-Edit",
	"Descriptors":
	{
		"TeamDetails.Name":
		{
			"Name": "Name",
			"Hash": "Team-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Team-Edit-Identity",
				"Group": "Team-Edit-Identity"
			}
		},
		"TeamDetails.Description":
		{
			"Name": "Description",
			"Hash": "Team-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Team-Edit-Details",
				"Group": "Team-Edit-Details"
			}
		},
		"TeamDetails.ParentIDTeam":
		{
			"Name": "Parent Team",
			"Hash": "Team-Edit-ParentIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Team-Edit-Details",
				"Group": "Team-Edit-Details",
				"Entity": "Team",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TeamDetails.IDTeam":
		{
			"Name": "IDTeam",
			"Hash": "Team-Edit-IDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.GUIDTeam":
		{
			"Name": "GUIDTeam",
			"Hash": "Team-Edit-GUIDTeam",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Team-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Team-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Team-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		},
		"TeamDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Team-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Team-Edit-DataAudit",
				"Group": "Team-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Team-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Team-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Team-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Team-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Team-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Team-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
